<template>
  <footer>
    <div class="pc-content" v-if="!isShowMobile">
      <div class="p-links">
        <div class="item">
          <a href="privacy.html"><span class="link link_first">{{ $t('footer.priv') }}</span></a>
          <!-- <router-link :to="'privacy.html'">
            <span class="link link_first">{{ $t('footer.priv') }}</span>
          </router-link> -->
          <a href="userve.html"><span class="link link_first">{{ $t('footer.userve') }}</span></a>
          <!-- <router-link :to="'/userve'">
            <span class="link link_first">{{ $t('footer.userve') }}</span>
          </router-link> -->
        </div>
        <div class="item">
          <span>{{ $t('footer.contact') }}:</span>
          <span>user_service@newlang.cn</span>
        </div>
        <div class="item">
          <span>{{ $t('footer.email') }}:</span>
          <span>bd@newlang.cn</span>
        </div>
      </div>
    </div>
    <div class="mobile-content" v-if="isShowMobile">
      <div class="m-links">
        <div class="item">
          <!-- <router-link :to="'/priv'">
            <span class="link link_first">{{ $t('footer.priv') }}</span>
          </router-link> -->
          <a href="privacy.html"><span class="link link_first">{{ $t('footer.priv') }}</span></a>
          <span>{{ $t('footer.contact') }}:</span>
          <span>user_service@newlang.cn</span>
        </div>
        <div class="item">
          <!-- <router-link :to="'/userve'">
            <span class="link link_first">{{ $t('footer.userve') }}</span>
          </router-link> -->
          <a href="userve.html"><span class="link link_first">{{ $t('footer.userve') }}</span></a>
          <span>{{ $t('footer.email') }}:</span>
          <span>bd@newlang.cn</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang='ts'>
import { useWindowSizeFn } from '@/hooks/useWindowSizeFn'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'MFooter',
  setup() {
    const contentWeight = ref(window.innerWidth)
    const isShowMobile = ref(false)
    useWindowSizeFn(
      () => {
        contentWeight.value = window.innerWidth
        if (contentWeight.value <= 825) {
          isShowMobile.value = true
          return
        }
        isShowMobile.value = false
      },
      200,
      { immediate: true }
    )

    return {
      isShowMobile,
      contentWeight
    }
  }
})
</script>
<style lang='scss' scoped>
footer {
  width: 100%;
  background-color: #6667AB;
}

.pc-content {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
}

.p-links {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: space-evenly;
  padding-top: 6px;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}

.item .link {
  display: block;
  font-weight: 600;
  color: #ffffff;
  margin: 5px 0;
  text-decoration: none;
  font-size: 25px;
}

.mobile-content {
  height: 100%;
  width: 100%;
}

.m-links {
  display: flex;
  justify-content: space-evenly;
  height: 150px;
}
</style>
